import { useEffect } from 'react';
import QrPlaceholder from '@/components/base/QrPlaceholder';

interface PurchaseQrModalProps {
  open: boolean;
  onClose: () => void;
  courseTitle: string;
  price: number;
}

const steps = [
  { id: 1, icon: 'ri-qr-scan-2-line', label: '微信扫一扫' },
  { id: 2, icon: 'ri-apps-2-line', label: '进入小程序' },
  { id: 3, icon: 'ri-shield-check-line', label: '完成支付' },
];

export default function PurchaseQrModal({ open, onClose, courseTitle, price }: PurchaseQrModalProps) {
  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center px-4 animate-modal-fade bg-foreground-950/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-lg border border-background-200 bg-background-50 p-6 md:p-8 text-center animate-modal-pop"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="扫码购买"
      >
        <button
          type="button"
          aria-label="关闭"
          onClick={onClose}
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <i className="ri-close-line text-xl"></i>
        </button>

        <div className="flex items-center justify-center gap-2 mb-2">
          <span className="w-1.5 h-4 rounded-full bg-primary-500"></span>
          <span className="text-sm font-medium text-primary-600">扫码购买</span>
        </div>
        <h3 className="font-heading text-lg font-bold leading-snug text-foreground-900 line-clamp-2">
          {courseTitle}
        </h3>
        <p className="mt-2 font-heading text-2xl font-bold text-primary-600">
          ¥{price}
        </p>

        <div className="w-52 h-52 mx-auto mt-5 p-3 rounded-lg bg-background-50 border border-background-200">
          <QrPlaceholder />
        </div>

        <p className="flex items-center justify-center gap-1.5 mt-4 text-sm text-foreground-700">
          <i className="ri-wechat-line text-accent-600"></i>
          请使用微信扫码，进入小程序完成支付
        </p>

        <div className="grid grid-cols-3 gap-2 mt-5">
          {steps.map((step) => (
            <div key={step.id} className="flex flex-col items-center gap-2 rounded-md bg-background-100 py-3 px-1">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50 text-primary-600">
                <i className={step.icon}></i>
              </span>
              <span className="text-xs text-foreground-600 whitespace-nowrap">{step.label}</span>
            </div>
          ))}
        </div>

        <p className="mt-5 text-xs leading-relaxed text-foreground-400">
          支付将在「元合 VITA」小程序内完成，官网仅提供扫码入口
        </p>
      </div>
    </div>
  );
}